module.exports = __webpack_public_path__ + "static/media/P1-phone.a490425f.png";